export interface TenantState {
    tenantKey: string | null; 
    isEncrypted: boolean; 
}

export const initialTenantState: TenantState = {
    tenantKey: null,
    isEncrypted: false
};
